<template>
  <Toast ref="Toast" :Content="content" />
  <router-view/>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'

import { Auth } from '@/mixins/Auth'
import { Groupbuy } from '@/mixins/Groupbuy'
import SocketService from '@/Service/SocketService'

import Toast from '@/components/Toast'
import axios from 'axios'

export default {
  name: "APP",
  mixins: [Auth, Groupbuy],
  components: { Toast },
  data () {
    return {
      Global: Global,
      content: ''
    }
  },
  async mounted() {
    console.log('Vue Router 識別路徑:', this.$route.path);
    await this.isLogin()
    this.emitIdentify()
    SocketService.startUserHeartbeat()
    const sock = window.Echo?.connector?.socket
    if (sock) sock.on('connect', () => this.emitIdentify())
    Global.on(Global.EVENT.CHECK_USER_LOGIN, () => this.emitIdentify())

    /* 全局顯示 Toast */
    Global.on('ToastContent', (content) => {
      this.$data.content = content
      $('.toast').toast('show')
    })
  },
  beforeUnmount() {
    SocketService.clearUserHeartbeat()
  },
  methods: {
    emitIdentify () {
      const sock = window.Echo?.connector?.socket
      if (!sock?.connected || !Global.User?.id) return
      const isGuest = Global.isGuest === true
      sock.emit('identify', {
        user_id: Global.User.id,
        type: isGuest ? 'guest' : 'user',
        is_guest: isGuest,
      })
    },
    /* 重新載入 getUserGroupbuies */
    getUserGroupbuies: function() {
      axios.get(Global.Domain + `/getUserGroupbuies`)
      .then((response) => {
        let Groupbuies = response.data
        Groupbuies.forEach((data) => this.receiveGroupbuy(data))
      })
    }
  }
}
</script>